"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'config.tooltips.chat.pick.kdb': 'Seleccionar base de datos de conocimiento para respuestas mejoradas',
    'config.tooltips.chat.settings': 'Abrir configuración de chat para configurar opciones',
    'config.tooltips.send.prompt': 'Enviar mensaje',
    'config.tooltips.prompt.with.microphone': 'Mensaje con micrófono',
    'config.tooltips.attach.file.to.prompt': 'Adjuntar archivo al mensaje',
    'config.tooltips.cancel.request': 'Cancelar solicitud',
};
